import { Component, OnInit } from '@angular/core';
import { ModuloService } from 'src/app/services/modulo.service';

@Component({
  selector: 'partial-destaques',
  templateUrl: './destaques.component.html',
  styleUrls: ['./destaques.component.scss']
})
export class DestaquesComponent implements OnInit {

  public _modulos = [];  
  public posicao  = ["chamada","banner-destaque","produto-categoria-destaque","produto-novidade","produto-promocao","produto-by-categoria"] 

  constructor(
    private modulo:ModuloService
  ) { }

  /**
   * 
   * @param posicao 
   * 
   */
  hasPosicao(p){

    let status = false;

    for (let index = 0; index < this.posicao.length; index++) {
      
      if(this.posicao[index] == p){

        status = true;
        break;

      }
      
    }

    return status;

  }
  /**
   * 
   * @param data 
   * 
   */
  setModulos(data){

    for (let index = 0; index < data.length; index++) {
      
      if(this.hasPosicao(data[index].posicao)){

        this._modulos.push(data[index]);

      }
      
    }

  }
  /**
   * 
   * Set Data
   * 
   */
  setData(){

    this.modulo.updateModulosEmitter.subscribe(data =>{
      
      if(data != null){
        this.setModulos(data);
      }  

    });
    this.modulo.getModulosEmitter.emit(); 


  
  }
  /**
   * 
   * Inicaliza as Funções
   * 
   */
  ngOnInit(): void {
    this.setData();
  }

}
